const messages = {
  name: 'Licencia |||| Licencias',
  fields: {
    name: 'Nombre de Licencia',
  },
  empty: 'No hay licencias todavia',
  invite: 'Anade tu primera licencia',
  create: {
    title: 'Crear Licencia',
  },
  edit: {
    title: 'Editar Licencia',
  },
  dialog: {
    title: 'Detalles de Licencia',
  },
  sections: {
    basicInfo: 'Informacion Basica',
  },
  filters: {
    licenseName: 'Nombre de Licencia',
  },
  actions: {
    addLicense: 'Anadir Licencia',
    discard: 'Descartar',
    submit: 'Enviar',
  },
  validation: {
    nameRequired: 'El nombre de la licencia es obligatorio',
    nameMaxLength: 'El nombre debe tener como maximo %{max} caracteres',
  },
  help: {
    createBanner: 'Anade una nueva licencia a tu cuenta de Notify.',
    editBanner: 'Actualiza los detalles de la licencia.',
    name: 'El nombre de la licencia. Debe ser unico.',
  },
  delete: {
    title: 'Eliminar licencia "%{recordName}"',
    content: 'Seguro que quieres eliminar esta licencia? Esta accion no se puede deshacer.',
  },
  notifications: {
    created: 'Licencia creada correctamente',
    updated: 'Licencia actualizada correctamente',
    deleted: 'Licencia eliminada correctamente',
    loadFailed: 'Error al cargar la licencia',
    createFailed: 'Error al crear la licencia',
    updateFailed: 'Error al actualizar la licencia',
  },
};

export default messages;
